import { ALSkeleton } from "../../ALComponents";

function UpSellItemPlaceholder() {
  return (
    <div
      data-testid="upsell-item-placeholder"
      className="flex justify-between border border-dark-grey w-[80%] p-[10px] rounded-[8px]"
    >
      <ALSkeleton width="80px" height="100px" />
      <div className="flex justify-between w-[calc(100%-90px)] ml-[10px]">
        <ALSkeleton width="60px" height="24px" />
        <ALSkeleton width="30px" height="24px" />
      </div>
    </div>
  );
}

export default UpSellItemPlaceholder;
